import fetchRamsSignings from '../Services/fetchRamsSignings'
import { setPagination } from '../State/pagination'

export default () => (dispatch) => {

  dispatch(setPagination({ current: 1 }))

  dispatch(fetchRamsSignings())

}
